import script from "./ClearBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClearBtn.vue?vue&type=script&lang=ts&setup=true"

import "./ClearBtn.vue?vue&type=style&index=0&id=b7d77d58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7d77d58"]])

export default __exports__